import React from "react"
import HeadingCover from "../../../components/text/heading-cover/heading-cover"
import { StaticImage } from "gatsby-plugin-image"
import BodyText from "../../../components/text/body-text/body-text"
import { useState } from "react"
import * as styles from "./index.module.css"
import StepsMaker from "../../../components/StepsMaker/StepsMaker"

const commonImageProps = {
  layout: "constrained",
  placeholder: "blurred",
  formats: ["auto", "webp"],
  outputPixelDensities: [0.5, 0.75, 1, 2],
}

export const DreamJob = () => {
  const steps = [
    {
      stepNumber: 1,
      title: "Counselling",
      description:
        "Your unique strengths & interests are evaluated through skills & competency mapping to create a personalized career roadmap.",
      image: (
        <StaticImage
          src="../../../images/index/header/Group 73822.svg"
          alt="Two professionals discussing career pathways during a counselling session"
          className={styles.dreamImg}
          {...commonImageProps}
        />
      ),
    },
    {
      stepNumber: 2,
      title: "Entry Gate Assessment (EGA)",
      description:
        "Aptitude & personality tests are done to gauge your fitment for the industry.",
      image: (
        <StaticImage
          src="../../../images/index/header/OBJECTS.svg"
          alt="Animated illustration of a male holding a tablet for entry gate assessment"
          className={styles.dreamImg}
          {...commonImageProps}
        />
      ),
    },
    {
      stepNumber: 3,
      title: "Course Selection",
      description:
        "Based on your counseling and EGA, we will help you choose the course that sets you up for success.",
      image: (
        <StaticImage
          src="../../../images/index/header/OBJECTS (1).svg"
          alt="Laptop screen displaying course options for selection"
          className={styles.dreamImg}
          {...commonImageProps}
        />
      ),
    },
    {
      stepNumber: 4,
      title: "Training",
      description:
        "Industry-aligned training through expert-led sessions, practical exposure, & a 360° learning approach that builds both technical & life skills.",
      image: (
        <StaticImage
          src="../../../images/index/header/Group 76599.svg"
          alt="Female trainer explaining concepts during a training session"
          className={styles.dreamImg}
          {...commonImageProps}
        />
      ),
    },
    {
      stepNumber: 5,
      title: "Post- Assessment & Certification",
      description:
        "Complete a final assessment to measure your progress & earn an industry-recognized certification.",
      image: (
        <StaticImage
          src="../../../images/index/header/certi.png"
          alt="Illustration of a certificate representing post-assessment certification"
          className={styles.dreamImg}
          {...commonImageProps}
        />
      ),
    },
    {
      stepNumber: 6,
      title: "Placement",
      description:
        "Our dedicated placement team connects you with top local & national employers, ensuring you get at least two job opportunities.",
      image: (
        <StaticImage
          src="../../../images/index/header/Group 76619.svg"
          alt="Animated image of a candidate celebrating job placement with 'I got the job' sign"
          className={styles.dreamImg}
          {...commonImageProps}
        />
      ),
    },
    {
      stepNumber: 7,
      title: "Lifelong Learning & Mentorship",
      description:
        "We're here for you beyond training, supporting your career transition with guidance, problem-solving, & resources.",
      image: (
        <StaticImage
          src="../../../images/index/header/Characters.svg"
          alt="Illustration of one person helping another climb a step, symbolizing lifelong mentorship"
          className={styles.dreamImg}
          {...commonImageProps}
        />
      ),
    },
  ]

  const [expandedDivIndex, setExpandedDivIndex] = useState(null)

  const toggleExpand = index => {
    setExpandedDivIndex(expandedDivIndex === index ? null : index)
  }

  return (
    <>
      <HeadingCover className="px-4 text-center mb-[60px] mx-auto">
        <span>The Road To</span> Your Dream Job
      </HeadingCover>

      <StepsMaker steps={steps} showInfoIcon={true} />
    </>
  )
}
